import { APP_URL } from "../constants";
import { httpClient } from "../utils/http-client";

const addExchange = async (exchangeInfo, token) => {
  try {
    return await httpClient.postFile(`${APP_URL}/v1/fx/rates`, exchangeInfo, {
      Authorization: `Bearer ${token}`,
      locale: navigator.language,
    });
  } catch (error) {
    console.log("Error creating a new Exchange Rate", error);
    return error;
  }
};

const fetchExchange = async (token) => {
  try {
    return httpClient.get(`${APP_URL}/v1/fx/rates`, {
      Authorization: `Bearer ${token}`,
      locale: navigator.language,
    });
  } catch (error) {
    console.log("Error getting Exhange Rates", error);
  }
};

const updateAmount = async (id, data, token) => {
  try {
    return httpClient.put(APP_URL + `/v1/fx/rates/${id}`, data, {
      Authorization: `Bearer ${token}`,
      locale: navigator.language,
    });
  } catch (error) {
    console.log("Error updating rate amount", error);
    return error;
  }
};

export { fetchExchange, updateAmount, addExchange };
